document.addEventListener('DOMContentLoaded', function () {
    const langSwitchers = document.querySelectorAll('.lang-switcher');
    for (const langSwitcher of langSwitchers) {
        if (langSwitcher) {
            langSwitcher.querySelector('.lang-active').addEventListener('click', () => {
                langSwitcher.querySelector('ul').classList.toggle('active');
            });
        }
    }

    document.addEventListener('click', function (e) {
        const langSwitchers = document.querySelectorAll('.lang-switcher');
        for (const langSwitcher of langSwitchers) {
            if (!langSwitcher.contains(e.target)) {
                langSwitcher.querySelector('ul').classList.remove('active');
            }
        }
    });
});
